export default __webpack_public_path__ + "static/media/dtsu5168_ct_gw214.0dc56ffa.jpg";